import { AxeIcon } from 'lucide-react';
import { Select, SelectContent, SelectItem } from '@/components/ui/select';
import * as SelectPrimitive from '@radix-ui/react-select';
import { socket } from '@/api/socket';
import { SOCKET_EVENTS } from '@/api/socket-events';

export default function VbivStatus({ clientId, takeStatus, takenFrom }: { clientId: string; takeStatus?: 0 | 1 | 2 | 3; takenFrom?: string }) {
	const iconStyle = {
		'0': 'text-gray-500',
		'1': 'text-chart-4',
		'2': 'text-chart-2',
		'3': 'text-[#c09b83]',
	};

	function handleChangeTakeStatus(val: string) {
		return socket.emit(SOCKET_EVENTS.changeTakeStatus, { clientId: clientId, status: Number(val) });
	}

	return (
		<Select value={String(takeStatus)} defaultValue={String(takeStatus)} onValueChange={handleChangeTakeStatus}>
			<SelectPrimitive.Trigger asChild>
				<div className={`border p-1 rounded-md flex gap-1 items-center cursor-pointer`}>
					<AxeIcon size={20} className={iconStyle[takeStatus ?? 0]} />
					{takeStatus === 1 && <div className='text-[#ad46ff] font-semibold'>{takenFrom}</div>}
				</div>
			</SelectPrimitive.Trigger>

			<SelectContent>
				<SelectItem value='0'>
					<AxeIcon size={20} className='text-gray-500' /> Не вбит
				</SelectItem>
				<SelectItem value='1'>
					<AxeIcon size={20} className='text-chart-4' /> На вбиве
				</SelectItem>
				<SelectItem value='2'>
					<AxeIcon size={20} className='text-chart-2 ' /> Успешно вбит
				</SelectItem>
				<SelectItem value='3'>
					<AxeIcon size={20} className='text-[#c09b83]' /> Говно
				</SelectItem>
			</SelectContent>
		</Select>
	);
}
